import { Link, Outlet, Route, Routes } from "react-router-dom";
import List from "./List";
import Create from "./Create";
import { useEffect, useState } from "react";
import * as auth from "./auth";

function Layout() {
  return (
    <>
      <div className="d-grid gap-2 d-md-block">
        <Link className="btn btn-primary" to="/">
          Create Alias
        </Link>
        <Link className="btn btn-primary" to="/list">
          List Aliases
        </Link>
      </div>
      <Outlet />
    </>
  );
}

function App() {
  let [error, setError] = useState("");
  useEffect(() => {
    async function doAsync() {
      try {
        await auth.start();
      } catch (error) {
        if (error instanceof Error) setError(error.message);
        else {
          console.error("Unexpected error", error);
          setError("Unknown error.");
        }
      }
    }
    doAsync();
  }, []);
  if (error != "") {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Create />} />
        <Route path="/list" element={<List />} />
      </Route>
    </Routes>
  );
}

export default App;
